import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@shared/components/ui/shadcn/toast';
import { useToast } from '@shared/hooks/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        duration,
        createdAt,
        ...props
      }) {
        return (
          <Toast key={id} duration={duration} createdAt={createdAt} {...props}>
            <div className="grid gap-1">
              {title && (
                <ToastTitle variant={props.variant ?? 'default'}>
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription variant={props.variant ?? 'default'}>
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
